module.exports = __webpack_public_path__ + "h5/img/noUseCoupon.ec900b34.png";